export const quoteIcon = {
  path: (
    <path
      d="M46.5571 0C16.3149 1.56682 0 18.0184 0 46.6129V85H48.5467V40.7373H27.8547C27.8547 26.2442 33.4256 19.5853 46.5571 17.235V0ZM113.01 0C82.7682 1.56682 66.4533 18.0184 66.4533 46.6129V85H115V40.7373H94.308C94.308 26.2442 99.8789 19.5853 113.01 17.235V0Z"
      fill="currentColor"
    />
  ),
  viewBox: "0 0 115 85",
}
